import { render, staticRenderFns } from "./ProductListCards.vue?vue&type=template&id=b24c80b2&scoped=true&"
import script from "./ProductListCards.vue?vue&type=script&lang=js&"
export * from "./ProductListCards.vue?vue&type=script&lang=js&"
import style0 from "./ProductListCards.vue?vue&type=style&index=0&id=b24c80b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24c80b2",
  null
  
)

export default component.exports